import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducer';
import { Form } from '../../models/forms.model';

export default function useForms(): Form[] {
  const selectedCommunity = useSelector((state: RootState) => state.application.selectedCommunity);
  const formsMap = useSelector((state: RootState) => state.forms.formsMap);

  if (!selectedCommunity) return [];
  return formsMap[selectedCommunity] || [];
}

export function useCurrentForm(): Form | null {
  return useSelector((state: RootState) => state.forms.currentForm);
}
